// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\PilotAgency\ApiPilotAgency.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { AgencyCode, AgencyCodeData, AgencyCodeOptions } from 'data/models/AgencyCode';
import { DispatchEvent, DispatchEventData, DispatchEventOptions } from 'data/models/DispatchEvent';
import { LineHandlingCompany, LineHandlingCompanyData, LineHandlingCompanyOptions } from 'data/models/LineHandlingCompany';
import { Organization, OrganizationData, OrganizationOptions } from 'data/models/Organization';
import { PilotJobOrder, PilotJobOrderData, PilotJobOrderOptions } from 'data/models/PilotJobOrder';
import { PilotSection, PilotSectionData, PilotSectionOptions } from 'data/models/PilotSection';
import { TugCompany, TugCompanyData, TugCompanyOptions } from 'data/models/TugCompany';

// PilotAgencyData is the class that PilotAgency serializes to/from
export interface PilotAgencyData {
    Id : number;
    Url : string | null;
	
    AgencyCodes : AgencyCodeData[] | null;
    DispatchEvents : DispatchEventData[] | null;
    DispatchEventsUrl : string | null;
    JobOrders : PilotJobOrderData[] | null;
    LineHandlingCompanies : LineHandlingCompanyData[] | null;
    LineHandlingCompaniesUrl : string | null;
    Organization : OrganizationData | null;
    Sections : PilotSectionData[] | null;
    SectionsUrl : string | null;
    TugCompanies : TugCompanyData[] | null;
    TugCompaniesUrl : string | null;
	
    AgencyCodesUrlBase : string | null;
}

// PilotAgencyOptions is the class which may be passed to the PilotAgency constructor to define optional initial data values
export interface PilotAgencyOptions {
    Id : number;
    Url? : string | null;
	
    AgencyCodes? : AgencyCodeOptions[] | null;
    DispatchEvents? : DispatchEventOptions[] | null;
    DispatchEventsUrl? : string | null;
    JobOrders? : PilotJobOrderOptions[] | null;
    LineHandlingCompanies? : LineHandlingCompanyOptions[] | null;
    LineHandlingCompaniesUrl? : string | null;
    Organization? : OrganizationOptions | null;
    Sections? : PilotSectionOptions[] | null;
    SectionsUrl? : string | null;
    TugCompanies? : TugCompanyOptions[] | null;
    TugCompaniesUrl? : string | null;
	
    AgencyCodesUrlBase? : string | null;
}

export class PilotAgency {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public AgencyCodes : SDataArray<AgencyCode>;
    public DispatchEvents : SDataArray<DispatchEvent>;
    public DispatchEventsUrl : DataSignal<string | null>;
    public JobOrders : SDataArray<PilotJobOrder>;
    public LineHandlingCompanies : SDataArray<LineHandlingCompany>;
    public LineHandlingCompaniesUrl : DataSignal<string | null>;
    public Organization : DataSignal<Organization | null>;
    public Sections : SDataArray<PilotSection>;
    public SectionsUrl : DataSignal<string | null>;
    public TugCompanies : SDataArray<TugCompany>;
    public TugCompaniesUrl : DataSignal<string | null>;
	
    public AgencyCodesUrlBase : DataSignal<string | null>;

    constructor();
    constructor(data : PilotAgencyOptions);
    constructor(data: PilotAgencyOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.AgencyCodes = SArray<AgencyCode>([]);
        this.DispatchEvents = SArray<DispatchEvent>([]);
        this.DispatchEventsUrl = jsonableObservable(S.value<string | null>(data && data.DispatchEventsUrl !== undefined ? data.DispatchEventsUrl : null));
        this.JobOrders = SArray<PilotJobOrder>([]);
        this.LineHandlingCompanies = SArray<LineHandlingCompany>([]);
        this.LineHandlingCompaniesUrl = jsonableObservable(S.value<string | null>(data && data.LineHandlingCompaniesUrl !== undefined ? data.LineHandlingCompaniesUrl : null));
        this.Organization = S.value<Organization | null>(null);
        this.Sections = SArray<PilotSection>([]);
        this.SectionsUrl = jsonableObservable(S.value<string | null>(data && data.SectionsUrl !== undefined ? data.SectionsUrl : null));
        this.TugCompanies = SArray<TugCompany>([]);
        this.TugCompaniesUrl = jsonableObservable(S.value<string | null>(data && data.TugCompaniesUrl !== undefined ? data.TugCompaniesUrl : null));
	    
        this.AgencyCodesUrlBase = jsonableObservable(S.value<string | null>(data && data.AgencyCodesUrlBase !== undefined ? data.AgencyCodesUrlBase : null));
    }

    static key(obj : PilotAgency) {
        return obj.Id();
    }
    
    static dataKey(obj : PilotAgencyOptions) {
        return obj.Id;
    }

    static update(obj : PilotAgency, data : PilotAgencyOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.DispatchEventsUrl !== undefined) obj.DispatchEventsUrl(data.DispatchEventsUrl);
            if (data.LineHandlingCompaniesUrl !== undefined) obj.LineHandlingCompaniesUrl(data.LineHandlingCompaniesUrl);
            if (data.SectionsUrl !== undefined) obj.SectionsUrl(data.SectionsUrl);
            if (data.TugCompaniesUrl !== undefined) obj.TugCompaniesUrl(data.TugCompaniesUrl);
	        
            if (data.AgencyCodesUrlBase !== undefined) obj.AgencyCodesUrlBase(data.AgencyCodesUrlBase);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PilotAgency.ts